import { isCustomChartsEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { isGeolocationEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { isHeatmapEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { isTimeSeriesTrendsEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { isKeyFactorsEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { isPipelineAnalysisEnabledForAtLeastOneConfigForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { isProgressEnabledForRevision } from 'libs/end-to-end/src/common-revision-flags';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { determineEntitledDetailsForFocusAreaPage } from 'libs/end-to-end/src/focus-area-utils';
import { guardExhaustive } from 'libs/end-to-end/src/generic';
import { isEntitledToDashboards } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToGeolocation } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToHeatmap } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToRichText } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToSummaryStats } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToTableView } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToPipelineAnalysis } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToProgress } from 'libs/end-to-end/src/group-entitlements';
import { isEntitledToSuccessFactors } from 'libs/end-to-end/src/group-entitlements';
import { MyObservation } from 'libs/end-to-end/src/my-observation';

export const getFeaturesForNewChart = (
  myObservation: MyObservation,
): FiltersFeatureName[] =>
  // eslint-disable-next-line complexity
  FiltersFeatureName.options.filter((f) => {
    switch (f) {
      case 'binScatterMultiSelect':
        return myObservation.focusAreas.some(
          ({ focusArea }) =>
            determineEntitledDetailsForFocusAreaPage({
              focusArea,
              observation: myObservation,
            }).binScatterMultiSelectEnabled,
        );
      case 'dataIntelligenceDeepDive':
        return myObservation.focusAreas.some(
          ({ focusArea }) =>
            determineEntitledDetailsForFocusAreaPage({
              focusArea,
              observation: myObservation,
            }).dataIntelligenceDeepDiveEnabled,
        );
      case 'progressPage':
        return (
          isProgressEnabledForRevision({ revisionFlags: myObservation }) &&
          isEntitledToProgress({
            features: myObservation.features,
            focusArea: null,
          })
        );
      case 'exploreHeatmap':
        return (
          isHeatmapEnabledForRevision({ revisionFlags: myObservation }) &&
          isEntitledToHeatmap({
            features: myObservation.features,
            focusArea: null,
          })
        );
      case 'successFactors':
        return (
          isKeyFactorsEnabledForRevision({ revisionFlags: myObservation }) &&
          isEntitledToSuccessFactors({
            features: myObservation.features,
            focusArea: null,
          })
        );
      case 'employeeLifecycle':
        return (
          isPipelineAnalysisEnabledForAtLeastOneConfigForRevision({
            revisionFlags: myObservation,
          }) &&
          isEntitledToPipelineAnalysis({ features: myObservation.features })
        );
      case 'tableView':
        return (
          isCustomChartsEnabledForRevision({ revisionFlags: myObservation }) &&
          isEntitledToTableView({
            features: myObservation.features,
            focusArea: null,
          })
        );
      case 'timeSeriesTrendsPrimary':
        return (
          isTimeSeriesTrendsEnabledForRevision({
            revisionFlags: myObservation,
          }) &&
          isEntitledToProgress({
            features: myObservation.features,
            focusArea: null,
          })
        );
      case 'summaryStats':
        return (
          isCustomChartsEnabledForRevision({ revisionFlags: myObservation }) &&
          isEntitledToSummaryStats({
            features: myObservation.features,
            focusArea: null,
          })
        );
      case 'richText':
        return (
          isCustomChartsEnabledForRevision({ revisionFlags: myObservation }) &&
          isEntitledToRichText({
            features: myObservation.features,
          })
        );
      case 'geolocation':
        return (
          isGeolocationEnabledForRevision({ revisionFlags: myObservation }) &&
          isEntitledToGeolocation({
            features: myObservation.features,
            focusArea: null,
          })
        );
      case 'externalStreamlit':
        return (
          isEntitledToDashboards({
            features: myObservation.features,
          }) && myObservation.showMyCustomApps
        );
      default:
        throw guardExhaustive(f);
    }
  });
